import axios from 'axios';
import * as types from './RestorePassword.types';
import * as selectors from './RestorePassword.selectors';
import { showNotification } from './../../utils';

const apiUrl = process.env.REACT_APP_API_URL;

export const savePassword = () => (dispatch, getState) => {
    const password = selectors.getPassword(getState());
    const confirmPassword = selectors.getConfirmPassword(getState());
    const token = selectors.getToken(getState());
    const loginType = selectors.getLoginType(getState());
    const history = selectors.getHistory(getState());

    if (password === '') {
        return showNotification('Complete Info', 'Enter the New Password field', 'info');
    }
    if (confirmPassword === '') {
        return showNotification('Complete Info', 'Enter the Confirm New Password field', 'info');
    }
    if (password !== confirmPassword) {
        return showNotification('Complete Info', 'The Confirm New Password field is different', 'info');
    }

    dispatch({ type: types.SAVE_PASSWORD, payload: null });
    axios.post(apiUrl + '/uthealth-order/save-password', { password, token },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SAVE_PASSWORD_SUCCESS, payload: response.data });
            showNotification('Success', 'Your password has been changed successfully, please login using your new password', 'success');

            if (parseInt(loginType) === 1) {
                history.push('/login');
            } else if (parseInt(loginType) === 2) {
                history.push('/personal-login');
            }
        })
        .catch((error) => {
            dispatch({ type: types.SAVE_PASSWORD_ERROR, payload: null });
            showNotification('Error', 'An error has occurred!', 'danger');
        });
}

export const setPassword = (value) => (dispatch) => {
    dispatch({
        type: types.SET_PASSWORD,
        payload: value
    });
}
export const setConfirmPassword = (value) => (dispatch) => {
    dispatch({
        type: types.SET_CONFIRM_PASSWORD,
        payload: value
    });
}
export const setToken = (value) => (dispatch) => {
    dispatch({
        type: types.SET_TOKEN,
        payload: value
    });
}
export const setLoginType = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LOGIN_TYPE,
        payload: value
    });
}
export const setHistory = (value) => (dispatch) => {
    dispatch({
        type: types.SET_HISTORY,
        payload: value
    });
}
export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}